if(!customElements.get("finance-offer-card-calculator")) customElements.define("finance-offer-card-calculator", class extends HTMLElement {

    connectedCallback() {
        this.shownSend = false;
        window.addEventListener('scroll', this.onScroll.bind(this));
        this.banner = this.getAttribute("banner");
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
        } else {
            this.onDOMContentLoaded();
        }
    }

    onDOMContentLoaded() {
        this.creditAmount = this.querySelector('finance-credit-amount');
        this.priceInput = this.querySelector('.fin_calc_price');
        this.priceInputSldier = this.querySelector('.fin_calc_price_slider');
        this.annuity = this.querySelector('finance-annuity');
        this.annuityIncome = this.querySelector('finance-annuity-required-income');
        this.pvPercent = this.querySelector('.fin_calc_pv_percent');
        this.pvInput = this.querySelector('.fin_calc_pv');
        this.pvSlider = this.querySelector('.fin_calc_pv_slider');
        this.rateInput = this.querySelector('.fin_calc_rate');
        this.rateSlider = this.querySelector('.fin_calc_rate_slider');
        this.termInput = this.querySelector('.fin_calc_term');
        this.termSlider = this.querySelector('.fin_calc_term_slider');
        this.termAddorment = this.querySelector('.fin_calc_term_admt');
        this.sendOfferButtons = this.querySelectorAll('finance-bank-send-offer-button');
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('change-pv', this.onChangePv.bind(this));
        this.addEventListener('change-term', this.onChangeTerm.bind(this));
        this.addEventListener('change-rate', this.onChangeRate.bind(this));
        this.addEventListener('change-payroll', this.onChangePayroll.bind(this));
        this.addEventListener('change-special-program', this.onChangeSpecialProgram.bind(this));
        this.onScroll();
    }

    sendEvent(name) {
        if(window.location.hostname.indexOf('cian.ru') >= 0 || window.location.hostname.indexOf('localhost') >= 0) {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', "https://widgets.fin.cian.ru/widget-statistics/widgets/events/offer-card-" + this.banner);
            xhr.withCredentials = true;
            xhr.send(JSON.stringify({name}));
        }
    }

    onScroll() {
        if(!this.shownSend) {
            var docViewTop = window.scrollY;
            var docViewBottom = docViewTop + window.innerHeight;

            var elemTop = this.offsetTop;
            var elemBottom = elemTop + this.scrollHeight;

            if ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) {
                this.sendEvent('shown');
                this.shownSend = true;
            }
        }
    }

    updatePrice(value) {
        this.querySelectorAll('[price]').forEach(e => {
            e.setAttribute('price', value);
        });

        if(this.creditAmount) this.creditAmount.setAttribute('price', value);
        if(this.annuity) this.annuity.setAttribute('price', value);
        if(this.annuityIncome) this.annuityIncome.setAttribute('price', value);
        if(this.pvPercent) this.pvPercent.setAttribute('total', value);
        if(this.pvSlider) this.pvSlider.setAttribute('max', Math.round(0.95 * value));
        if(this.pvSlider) this.pvSlider.setAttribute('min', Math.round(0.2 * value));
    }

    updatePv(value) {
        this.querySelectorAll('[initial-payment]').forEach(e => {
            e.setAttribute('initial-payment', value);
        });
        this.querySelectorAll('[event="change-pv"]').forEach(e => {
            e.setAttribute('slider-value', value);
        });
        this.querySelectorAll('[custom-event="change-pv"]').forEach(e => {
            e.setAttribute('slider-value', value);
        });

        if(this.annuity) this.annuity.setAttribute('initialPayment', value);
        if(this.annuityIncome) this.annuityIncome.setAttribute('initialPayment', value);
        if(this.pvPercent) this.pvPercent.setAttribute('value', value);
        if(this.sendOfferButtons && this.sendOfferButtons.length !==0 ) this.sendOfferButtons.forEach((v) => v.setAttribute('initialPayment', value));
    }


    updateTerm(value) {
        this.querySelectorAll('[term]').forEach(e => {
            e.setAttribute('term', value);
        });
        this.querySelectorAll('[event="change-term"]').forEach(e => {
            e.setAttribute('slider-value', value);
        });
        this.querySelectorAll('[custom-event="change-term"]').forEach(e => {
            e.setAttribute('slider-value', value);
        });

        if(this.annuity) this.annuity.setAttribute('term', value);
        if(this.annuityIncome) this.annuityIncome.setAttribute('term', value);
        if(this.termAddorment) this.termAddorment.setAttribute('value', value);
        if(this.sendOfferButtons && this.sendOfferButtons.length !==0 ) this.sendOfferButtons.forEach((v) => v.setAttribute('term', value));
    }

    updateRate(value) {
        this.querySelectorAll('[rate]').forEach(e => {
            e.setAttribute('rate', value);
        });
        if(this.annuity) this.annuity.setAttribute('rate', value);
        if(this.annuityIncome) this.annuityIncome.setAttribute('rate', value);
    }

    updatePayroll(value) {
        this.querySelectorAll('[payroll]').forEach(e => {
            e.setAttribute('payroll', value);
        });
    }

    updateSpecialProgram(value) {
        this.querySelectorAll('[special-program]').forEach(e => {
            e.setAttribute('special-program', value);
        });
    }

    onChangePv(e) {
        this.updatePv(e.value);
    }
    onChangeTerm(e) {
        this.updateTerm(e.value);
    }

    onChangeRate(e) {
        this.updateRate(e.value);
    }
    onChangePayroll(e) {
        this.updatePayroll(e.value);
    }
    onChangeSpecialProgram(e) {
        this.updateSpecialProgram(e.value);
    }

    onChange(e) {
        const {target, value} = e;
        if ([this.priceInput, this.priceInputSldier].indexOf(target) >= 0) {
            this.updatePrice(value);
        }
        if ([this.pvInput, this.pvSlider].indexOf(target) >= 0) {
            this.updatePv(value);
        }
        if ([this.rateInput, this.rateSlider].indexOf(target) >= 0) {
            this.updateRate(value);
        }
        if ([this.termInput, this.termSlider].indexOf(target) >= 0) {
            this.updateTerm(value);
        }
        e.stopPropagation();
    }

});
